export default "__VITE_ASSET__5f0f2377__"